/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import { useState, useEffect } from 'react';

export function updateIsLoaded(value) {
    sessionStorage.setItem('isLoaded', value);
    const event = new Event('isLoadedChanged');
    window.dispatchEvent(event);
  }

export const useIsLoaded = () => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const initialLoadStatus = sessionStorage.getItem('isLoaded') === 'true';
        setIsLoaded(initialLoadStatus);

        const handleIsLoadedChange = () => {
            const loadedStatus = sessionStorage.getItem('isLoaded') === 'true';
            setIsLoaded(loadedStatus);
        };

        window.addEventListener('isLoadedChanged', handleIsLoadedChange);

        return () => {
            window.removeEventListener('isLoadedChanged', handleIsLoadedChange);
        };
    }, []);

    return isLoaded;
};

export function updateIsActivated(value) {
    sessionStorage.setItem('isActivated', value);
    const event = new Event('isActivatedChanged');
    window.dispatchEvent(event);
  }

export const useIsActivated = () => {
    const [isActivated, setIsActivated] = useState(false);

    useEffect(() => {
        const initialActivatStatus = sessionStorage.getItem('isActivated') === 'true';
        setIsActivated(initialActivatStatus);

        const handleIsActivatedChange = () => {
            const activatedStatus = sessionStorage.getItem('isActivated') === 'true';
            setIsActivated(activatedStatus);
        };

        window.addEventListener('isActivatedChanged', handleIsActivatedChange);

        return () => {
            window.removeEventListener('isActivatedChanged', handleIsActivatedChange);
        };
    }, []);

    return isActivated;
};

export function updateIsDetected(value) {
    sessionStorage.setItem('isDetected', value);
    const event = new Event('isDetectedChanged');
    window.dispatchEvent(event);
  }

export const useIsDetected = () => {
    const [isDetected, setIsDetected] = useState(false);

    useEffect(() => {
        const initialDetectStatus = sessionStorage.getItem('isDetected') === 'true';
        setIsDetected(initialDetectStatus);

        const handleIsDetectedChange = () => {
            const detectedStatus = sessionStorage.getItem('isDetected') === 'true';
            setIsDetected(detectedStatus);
        };

        window.addEventListener('isDetectedChanged', handleIsDetectedChange);

        return () => {
            window.removeEventListener('isDetectedChanged', handleIsDetectedChange);
        };
    }, []);

    return isDetected;
};

export function updateJobID(value) {
    sessionStorage.setItem('JobIDis', value);
    const event = new Event('isJobIDChanged');
    window.dispatchEvent(event);
  }

export const useIsJobID = () => {
    const [JobIDis, setJobID] = useState('');

    useEffect(() => {
        const initialJobID = sessionStorage.getItem('JobIDis') || '';
        setJobID(initialJobID);

        const handleJobIDChange = () => {
            const detectedJobIDis = sessionStorage.getItem('JobIDis') || '';
            setJobID(detectedJobIDis);
        };

        window.addEventListener('isJobIDChanged', handleJobIDChange);

        return () => {
            window.removeEventListener('isJobIDChanged', handleJobIDChange);
        };
    }, []);

    return JobIDis;
};